import { render, staticRenderFns } from "./CommunityWelcomeModal.vue?vue&type=template&id=84b6cba8&"
import script from "./CommunityWelcomeModal.vue?vue&type=script&lang=js&"
export * from "./CommunityWelcomeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports